// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodRecipeId } from './FoodRecipe';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const foodRecipeStepId = (z.number());
export const foodRecipeStep = z.object({
    id: foodRecipeStepId,
    recipe_id: foodRecipeId,
    text: z.string(),
    ingredient_names: z.unknown().nullable(),
    note: z.string().nullable(),
    image_file_id: fileStorageId.nullable(),
    display_order: z.number(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const foodRecipeStepInitializer = z.object({
    id: foodRecipeStepId.optional(),
    recipe_id: foodRecipeId,
    text: z.string(),
    ingredient_names: z.unknown().optional().nullable(),
    note: z.string().optional().nullable(),
    image_file_id: fileStorageId.optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const foodRecipeStepMutator = z.object({
    id: foodRecipeStepId.optional(),
    recipe_id: foodRecipeId.optional(),
    text: z.string().optional(),
    ingredient_names: z.unknown().optional().nullable(),
    note: z.string().optional().nullable(),
    image_file_id: fileStorageId.optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=FoodRecipeStep.js.map